import { Routes } from "@angular/router";
import { SwitcherComponent } from "src/app/component/apps/switcher/switcher.component";

export const switchercontent: Routes = [
  {
    path: "switchercontent",
    loadChildren: () =>
      import("../../component/apps/apps.module").then((m) => m.AppsModule),
  },
];
